.notificationBanner {
    display: flex;
    align-items: center;
    flex: 1;
    background-color: var(--mantine-color-asurion-6);
    width: 100%;
    overflow: hidden;
    margin-bottom: var(--mantine-spacing-xxl);
    height: var(--mantine-spacing-xxl);
}

.notificationText {
    font-size: var(--mantine-font-size-xxs);
    color: var(--mantine-color-white);
    font-weight: var(--mantine-font-weight-heavy);
    text-align: left;
}

.notificationIcon {
    margin-left: calc(2 * var(--mantine-spacing-md));
}
